import { groupBy, orderBy } from "lodash";
import { Item__Atividades } from "../../../../../../../services/atividades/GET";
import { obterCodInsumoDashboard, obterNomeMediaLocal, unidade_medida_local } from "../../insumosPrecisao/meta";

export function normarlizarQtdeInoculante(quantidade: number, cod_medida: number, medida_dose_inoculante: string) {
    const medida_ino = String(medida_dose_inoculante)?.toLowerCase()?.replace('/ha', '');
    //já está em L
    if (medida_ino === 'ml' || medida_ino === 'l') {
        if (cod_medida === 1) {
            return { quantidade, medida: 'L', tipo_fisico: 'Líquido' };
        }

        //transformar mL em L
        if (cod_medida === 2) {
            return { quantidade: quantidade / 1000, medida: 'L', tipo_fisico: 'Líquido' };
        }
    }

    if (medida_ino === 'kg' || medida_ino === 'g') {
        if (cod_medida === 3 || cod_medida === 6) {
            return { quantidade, medida: 'kg', tipo_fisico: 'Sólido' };
        }
        //transformar g em kg
        if (cod_medida === 4) {
            return { quantidade: quantidade / 1000, medida: 'kg', tipo_fisico: 'Sólido' };
        }
    }

    //TODO
    //precisa tratar quando a medida for dose/ha

    return { quantidade: 0, medida: '' };
}

export function obterMedidaDoseInoculante(calculo_dosagem: string): string {
    const match = calculo_dosagem?.match(/[a-zA-Z]+$/);
    return match ? match[0] : '';
}

function obterNomeMediaInoculante(nome_medida: string) {
    const medida = String(nome_medida)?.toLowerCase();

    function tipoFisico() {
        if (medida === "ml" || medida === "l") {
            return 'Líquido';
        }
        return 'Sólido';
    }
    function obterCodMedida() {
        const encontrado = unidade_medida_local.find(i => i.nome.toLowerCase() === medida);
        return encontrado?.cod ?? 1;
    }
    return {
        nome: nome_medida,
        nome_completo: nome_medida,
        nome_filtro: nome_medida,
        tipo_fisico: tipoFisico(),
        cod_medida: obterCodMedida()
    };
};

export function obterListaInoculantes(todas_atividades_ativas: Item__Atividades[]): {
    cod_insumo: number,
    insumo_nome: string;
    quantidade_planejada: number;
    quantidade_executada: number;
    precisao: number;
    porcentagem: number;
    tipo_fisico: string;
    calculo_dosagem: string;
    ordem: number;
}[] {

    const incluir_tipo_atv = (todas_atividades_ativas ?? []).map(i => {
        return {
            ...i, andamentos: (i.andamentos ?? []).map(j => {
                return {
                    ...j, insumos: (j.insumos ?? []).map(k => {
                        return {
                            ...k,
                            tipo_atividade: i.cod_tipo === 1 ? "planejada" : "executada",
                            cod_tipo_atividade: i.cod_tipo
                        }
                    })
                }
            })
        }
    }).filter(i => i.delete_time === null);


    const apenas_insumos = (incluir_tipo_atv ?? []).map(i => {
        return i.andamentos.map(j => {
            return (j.insumos ?? []).map(k => {
                return {
                    cod: k.cod,
                    insumo_nome: k.insumo_nome,
                    cod_produto: k.cod_produto,
                    cod_fertilizante: k.cod_fertilizante,
                    cod_tecnologia: k.cod_tecnologia,
                    cod_variedade_hibrido: k.cod_variedade_hibrido,
                    cod_tipo: k.cod_tipo,
                    cod_tipo_atividade: k.cod_tipo_atividade,
                    composicao: k.composicao,
                    cod_medida: obterNomeMediaInoculante(obterMedidaDoseInoculante(k.calculo_dosagem)).cod_medida,
                    dosagem: k.dosagem,
                    maximo_abaixo: k.maximo_abaixo,
                    maximo_acima: k.maximo_acima,
                    quantidade: k.quantidade,
                    tipo_atividade: k.tipo_atividade,
                    nome_medida_filtro: obterNomeMediaInoculante(obterMedidaDoseInoculante(k.calculo_dosagem)).nome_filtro,
                    tipo_fisico_medida: obterNomeMediaInoculante(obterMedidaDoseInoculante(k.calculo_dosagem)).tipo_fisico,
                    calculo_dosagem: k.calculo_dosagem,
                    medida_dose_inoculante: obterMedidaDoseInoculante(k.calculo_dosagem),
                    cod_insumo: obterCodInsumoDashboard(k)
                    // nome_medida_completo: obterNomeMediaLocal(k.cod_medida).nome_completo,
                }
            })
        })
        //@ts-ignore
    }).flat(2)?.filter(i => i.cod_tipo === 8);

    const incluir_qtd_normalizada = (apenas_insumos ?? []).map(i => {
        return {
            ...i,
            quantidade_em_litros: normarlizarQtdeInoculante(i.quantidade, i.cod_medida, i.medida_dose_inoculante)?.quantidade,
            medida_inoculante_normalizada: normarlizarQtdeInoculante(i.quantidade, i.cod_medida, i.medida_dose_inoculante)?.medida,
            nome_inoculante_agrupar: `${i.insumo_nome} (${normarlizarQtdeInoculante(i.quantidade, i.cod_medida, i.medida_dose_inoculante)?.tipo_fisico}) [${i.calculo_dosagem}]`
        }
    });

    const insumos_planejados = (incluir_qtd_normalizada ?? []).filter(({ tipo_atividade }) => tipo_atividade === "planejada");
    const insumos_executados = (incluir_qtd_normalizada ?? []).filter(({ tipo_atividade }) => tipo_atividade === "executada");

    const agrupar_insumos_planejados = groupBy(insumos_planejados, "nome_inoculante_agrupar");
    const agrupar_insumos_executados = groupBy(insumos_executados, "nome_inoculante_agrupar");

    const totalizar_planejados = Object.entries(agrupar_insumos_planejados).map(([insumo_nome, insumos]) => {
        return {
            insumo_nome,
            quantidade: insumos.reduce((total, insumo) => total + insumo.quantidade_em_litros, 0)
        }
    });

    const totalizar_executados = Object.entries(agrupar_insumos_executados).map(([insumo_nome, insumos]) => {
        return {
            insumo_nome,
            quantidade: insumos.reduce((total, insumo) => total + insumo.quantidade_em_litros, 0)
        }
    });

    const insumos_consolidados: {
        cod_insumo: number;
        insumo_nome: string;
        quantidade_planejada: number;
        quantidade_executada: number;
        precisao: number;
        porcentagem: number;
        ordem: number;
        tipo_fisico: string;
        calculo_dosagem: string;
    }[] = [];

    // Combine planned and executed data
    const todos_insumos = new Set([...totalizar_planejados.map(i => i.insumo_nome), ...totalizar_executados.map(i => i.insumo_nome)]);

    todos_insumos.forEach(insumo_nome => {
        const primeiro_insumo = (agrupar_insumos_planejados[insumo_nome] || agrupar_insumos_executados[insumo_nome])?.[0];
        const cod_insumo = primeiro_insumo?.cod_insumo || null;

        const planejado = totalizar_planejados.find(i => i.insumo_nome === insumo_nome)?.quantidade || 0;
        const executado = totalizar_executados.find(i => i.insumo_nome === insumo_nome)?.quantidade || 0;

        let precisao = 0;
        let porcentagem = 0;

        if (planejado > 0) {
            const porcentagem_realizada = (executado / planejado) * 100;

            // Precision: 100 - |100 - executed%|
            // Represents how close the execution was to the plan (0-100%)
            precisao = 100 - Math.abs(100 - porcentagem_realizada);
            if (precisao < 0) precisao = 0;

            // Bar Percentage: Visual representation of execution.
            // As per user request: "não precisa compensar os 80%, pode exibir o valor real mesmo"
            // Example: 105% executed -> 105% bar.
            porcentagem = porcentagem_realizada;

        } else if (executado > 0) {
            precisao = 0;
            // Unplanned execution -> Percentage and Precision must be 0 as per user request.
            porcentagem = 0;
        }

        insumos_consolidados.push({
            cod_insumo,
            insumo_nome: insumo_nome?.replace(/\(([^)]+)\)/, '')?.replace(/\[([^\]]+)\]/, '')?.trim(),
            quantidade_planejada: Number(planejado?.toFixed(2)),
            quantidade_executada: Number(executado?.toFixed(2)),
            precisao: Number(precisao?.toFixed(2)),
            porcentagem: Number(porcentagem?.toFixed(2)),
            tipo_fisico: insumo_nome?.match(/\(([^)]+)\)/)?.[1] ?? '',
            calculo_dosagem: insumo_nome?.match(/\[([^\]]+)\]/)?.[1] ?? '',
            ordem: (planejado > 0 && executado > 0) ? 1 : (planejado === 0 && executado > 0) ? 2 : (planejado > 0 && executado === 0) ? 3 : 4
        });
    });

    return orderBy(insumos_consolidados, ["ordem", "quantidade_executada"], ["asc", "desc"]) ?? [];

}